<template>
  <div class="component-leadlist-step-1">
    <div v-if="optionsNotFound" class="small text-danger">
      Não foram encontrados dados suficientes na sua conta integrada.
      Certifique-se de configurar suas máquinas e funis em sua conta na
      LeadLovers.
    </div>

    <snow-select
      v-model="form.machine_code"
      id="machine_code"
      label="Primeiro selecione a máquina"
      :errors="errors.machine_code"
      :options="[...machine_options]"
      :disabled="loadingFetch.machine_code"
      :loading="loadingFetch.machine_code"
    />
    <snow-select
      v-model="form.sequence_code"
      id="sequence_code"
      label="Em seguida selecione o funil"
      :errors="errors.sequence_code"
      :options="[...sequence_options]"
      :disabled="!form.machine_code || loadingFetch.sequence_code"
    />
    <snow-select
      v-model="form.sequence_level_code"
      id="sequence_level_code"
      label="Então, selecione o e-mail (etapa do funil em que o lead entrará)"
      :errors="errors.sequence_level_code"
      :options="[...sequence_level_options]"
      :disabled="!form.sequence_code || loadingFetch.sequence_level_code"
    />
    <snow-select
      v-if="isSignature"
      v-model="form.plan_id"
      label="Selecione o plano (opcional)"
      :options="plans"
      id="offer-select"
      :errors="errors.plan_id"
      :disabled="loadingFetch.offer_plan"
    />
    <snow-selct
      v-else
      v-model="form.offer"
      label="Selecione a oferta (opcional)"
      :options="offers"
      :errors="errors.offer"
      id="offer-select"
      :disabled="loadingFetch.offer_plan"
    />
  </div>
</template>

<script>
import { clearObject } from "@/functions/helpers";
import { mapState } from "vuex";

export default {
  data() {
    return {
      loadingFetch: {
        machine_code: false,
        sequence_code: false,
        sequence_level_code: false,
        offer_plan: false
      },
      machine_options: [],
      sequence_options: [],
      sequence_level_options: [],
      params: {
        provider_id: this.provider.id,
        machine_code: "",
        sequence_code: ""
      }
    };
  },
  props: {
    product_id: {
      type: [Number, String],
      default: null
    },
    form: {
      type: Object,
      default: () => {}
    },
    provider: {
      type: Object,
      default: () => {}
    },
    errors: {
      type: Object,
      default: () => {}
    },
    isSignature: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapState("integration", ["providers", "mapProviderName", "tags"]),
    ...mapState("product", ["products"]),
    ...mapState("offer", ["offers"]),
    ...mapState("plan", ["plans"]),
    machineCode() {
      return this.machine_options.find(
        ({ id }) => id == this.form.machine_code
      );
    },
    sequenceCode() {
      return this.sequence_options.find(
        ({ id }) => id == this.form.sequence_code
      );
    },
    sequenceLevelCode() {
      return this.sequence_level_options.find(
        ({ id }) => id == this.form.sequence_level_code
      );
    },
    optionsNotFound() {
      return (
        !Object.values(this.loadingFetch).find(v => v) &&
        !this.machine_options.length &&
        !this.sequence_options.length &&
        !this.sequence_level_options.length
      );
    }
  },
  mounted() {
    this.fetchMachines();
    this.fetchSequencies();
    this.fetchSequenceLevel();
    this.getPlanOffer();
  },
  watch: {
    "form.machine_code"() {
      this.fetchSequencies();
    },
    "form.sequence_code"() {
      this.fetchSequenceLevel();
    }
  },
  methods: {
    getPlanOffer() {
      const action = this.isSignature ? "plan/get" : "offer/get";
      this.loadingFetch.offer_plan = true;
      this.$store
        .dispatch(action, {
          product_id: this.product_id
        })
        .then()
        .finally(() => {
          this.loadingFetch.offer_plan = false;
        });
    },
    fetchMachines() {
      this.params.provider_id = this.provider.id;
      this.loadingFetch.machine_code = true;

      this.$store
        .dispatch("integration/getMachines", clearObject(this.params))
        .then(({ response }) => {
          this.machine_options = (response.Items || []).map(m => ({
            ...m,
            id: m.MachineCode,
            name: m.MachineName
          }));
        })
        .finally(() => {
          this.loadingFetch.machine_code = false;
        });
    },
    fetchSequencies() {
      if (!this.form.machine_code) return;

      this.params.machine_code = this.form.machine_code;
      this.loadingFetch.sequence_code = true;

      this.$store
        .dispatch("integration/getSequencies", clearObject(this.params))
        .then(({ response }) => {
          this.sequence_options = (response.Items || []).map(m => ({
            ...m,
            id: m.SequenceCode,
            name: m.SequenceName
          }));
        })
        .finally(() => {
          this.loadingFetch.sequence_code = false;
        });
    },
    fetchSequenceLevel() {
      if (!this.form.machine_code || !this.form.sequence_code) return;

      this.params.provider_id = this.provider.id;
      this.params.machine_code = this.form.machine_code;
      this.params.sequence_code = this.form.sequence_code;

      this.loadingFetch.sequence_level_code = true;

      this.$store
        .dispatch("integration/getSequenceLevel", clearObject(this.params))
        .then(({ response }) => {
          this.sequence_level_options = (response.Items || []).map(m => ({
            ...m,
            id: m.ModelCode,
            name: m.Subject
          }));
        })
        .finally(() => {
          this.loadingFetch.sequence_level_code = false;
        });
    }
  }
};
</script>
<style scoped lang="scss">
.component-leadlist-step-1 {
  display: flex;
  flex-direction: column;
  gap: 16px;
}
</style>
